import { useMemo } from "react";
import { useParams } from "react-router";
import { DEEP_LINK_SERVICE_CONFIG_MAP, DeepLinkServiceConfig } from "generated/deepLinkServices";
import "./DeepLinkFallback.css";

const getMobileStoreUrl = (serviceConfig: DeepLinkServiceConfig) => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (/android/.test(userAgent)) {
        return serviceConfig.androidStoreUrl;
    }

    if (/iphone|ipad|ipod/.test(userAgent)) {
        return serviceConfig.iosStoreUrl;
    }

    return undefined;
};

const getAppOpenUrl = (serviceConfig: DeepLinkServiceConfig) => {
    const currentUrl = new URL(window.location.href);
    const userAgent = navigator.userAgent.toLowerCase();

    if (/android/.test(userAgent)) {
        const fallbackUrl = encodeURIComponent(serviceConfig.androidStoreUrl);
        return `intent://${currentUrl.host}${currentUrl.pathname}${currentUrl.search}#Intent;scheme=${currentUrl.protocol.replace(":", "")};package=${serviceConfig.androidPackageName};S.browser_fallback_url=${fallbackUrl};end`;
    }

    return currentUrl.toString();
};

export const DeepLinkFallback = () => {
    const { service } = useParams();
    const serviceConfig = service ? DEEP_LINK_SERVICE_CONFIG_MAP[service.toLowerCase()] : undefined;
    const storeUrl = useMemo(
        () => serviceConfig ? getMobileStoreUrl(serviceConfig) : undefined,
        [serviceConfig]
    );

    if (!serviceConfig) {
        return (
            <main className="deep-link-fallback">
                <section className="deep-link-fallback__content">
                    <div>
                        <h1 className="deep-link-fallback__title">지원하지 않는 링크입니다</h1>
                        <p className="deep-link-fallback__description">
                            링크 주소를 다시 확인해주세요.
                        </p>
                    </div>
                </section>
            </main>
        );
    }

    const openStore = () => {
        window.location.href = storeUrl ?? serviceConfig.androidStoreUrl;
    };

    const openApp = () => {
        window.location.href = getAppOpenUrl(serviceConfig);
    };

    return (
        <main className="deep-link-fallback">
            <section className="deep-link-fallback__content">
                <div>
                    <h1 className="deep-link-fallback__title">
                        {serviceConfig.displayName} 앱에서 확인해주세요
                    </h1>
                    <p className="deep-link-fallback__description">
                        앱이 설치되어 있지 않다면 스토어에서 {serviceConfig.displayName}를 설치한 뒤 다시 링크를 열어주세요.
                    </p>
                </div>

                <div className="deep-link-fallback__actions">
                    <button className="deep-link-fallback__button" type="button" onClick={openApp}>
                        앱으로 열기
                    </button>
                    <button className="deep-link-fallback__button" type="button" onClick={openStore}>
                        스토어로 이동
                    </button>
                </div>
            </section>
        </main>
    );
};
